import { useId } from 'react';
import { Box, Stack, Typography, useTheme } from '@mui/material';

import Seo from 'components/Seo';
import ServiceCard from 'components/ServiceCard';

import { services } from './utils';

const Services: React.FC = () => {
  const theme = useTheme();
  const servicesId = useId();

  return (
    <>
      <Seo
        title='Jyväskylän Huoltoykköset - Palvelut'
        description='Kausisäilytys, henkilö- ja pakettiautojen kaikki huollot ja korjaukset, renkaiden tasapainotus ja 3D-suuntaus, määräaikaishuollot – autosi takuu säilyy, sisätilalämmittimet Jyväskylä, henkilöauton ja pakettiauton käynnistimet, akut, laturit Jyväskylä, Jakopään huollot ja korjaukset, Ohjaus- ja jousitustyöt, Polttoainejärjestelmien huollot sekä korjaukset, Voimansiirron huollot ja korjaukset, sijaisautot huollon tai korjauksen ajaksi, Ilmastointi huolto ja korjaus, vikadiagnostiikka ja raportointi, ruostevauriokorjaukset, päästömittaukset ja diagnostiikat, öljynvaihdot, jäähdytysjärjestelmän huollot ja korjaukset, jarrujen huollot ja korjaukset, pakokaasujärjestelmien korjaustyöt'
        name='Jyväskylän Huoltoykköset: Palvelut'
        type='website'
      />
      <Stack
        id={servicesId}
        spacing={3}
        sx={{
          '&': {
            color: 'typography.light',
          },
        }}
      >
        <Stack spacing={3}>
          <Typography variant='h2'>TÄYDEN PALVELUN AUTOHUOLTO KUSTANNUSTEHOKKAASTI</Typography>
          <Stack spacing={2}>
            <Typography variant='p3' sx={{ color: 'rgba(238,240,242,0.75)' }}>
              Autohuoltomme kattaa laajan valikoiman palveluita autosi kunnon ylläpitämiseksi. Tavoitteenamme on tarjota luotettavaa ja
              tehokasta palvelua, kattamaan kaikki tarvittavat huollot ja korjaukset, yksinkertaisista teknisistä huolloista raskaisiin
              korjaustoimenpiteisiin. Pyrimme tekemään asiakaskokemuksestanne mukavan ja vaivattoman tarjoamalla laadukasta palvelua ja
              yksilöllistä lähestymistapaa jokaiseen asiakkaaseen.
            </Typography>
            <Typography variant='p3' sx={{ fontWeight: 'bold' }}>
              Palvelumme sisältää:
            </Typography>
          </Stack>
        </Stack>
        <Box
          display='grid'
          gridTemplateColumns='repeat(3, 1fr)'
          gap={2.25}
          sx={{
            [theme.breakpoints.down('md')]: {
              gridTemplateColumns: 'repeat(2, 1fr)',
            },
            [theme.breakpoints.down('sm')]: {
              gridTemplateColumns: 'repeat(1, 1fr)',
            },
          }}
        >
          {services.map(({ id, title, component }) => (
            <ServiceCard key={id} title={title} icon={component} />
          ))}
        </Box>
        <Typography variant='p3' sx={{ color: 'rgba(238,240,242,0.75)' }}>
          … ja kaikki muu mahdollinen autosi hyvinvoinnin tueksi!
        </Typography>
      </Stack>
    </>
  );
};

export default Services;
